<template>
  <div>
    <v-card>
      <v-card-title v-if="$route.params.item.displayName"
        ><v-btn icon @click.stop="goBack">
          <v-icon>mdi-arrow-left</v-icon> </v-btn
        >{{ $route.params.item.displayName }}</v-card-title
      >
      <v-card-text v-if="user.role != 'operateur'">
   <!--   <div>{{ $route.params.item }}</div> -->

        <v-form>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                disabled
                label="Identifiant"
                v-model="$route.params.item.id"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Nom"
                v-model="$route.params.item.displayName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                readonly
                label="Email"
                v-model="$route.params.item.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                readonly
                label="Mot de passe"
                v-model="$route.params.item.password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-col v-if="$route.params.item.isAnimateur === false">
              <DialogRegionsSupervisees :user="$route.params.item"
            /></v-col>

            <!--  <template v-if="$route.params.item.isAnimateur === true" > -->
            <template>
              <v-col v-if="user.role != 'operateur'">
                <DialogLocalisationDeUser :user="$route.params.item"
              /></v-col>

              <v-col> <DialogProjetsDeUser :user="$route.params.item" /></v-col>
              <!--       <v-col>
                <v-btn
                  rounded
                  color="success"
                  @click="goToGroupesDeSuperviseurs($route.params.item)"
                  ><v-icon left> mdi-account-group-outline</v-icon>
                  Groupes</v-btn
                >
              </v-col> -->
            </template>
          </v-row>
        </v-container>
      </v-card-actions>
      <v-card-actions v-if="user.role != 'operateur'">
        <v-spacer></v-spacer>
        <v-btn @click.stop="goBack" class="warning" rounded>Annuler</v-btn>
        <v-btn @click.stop="goBack" class="success" rounded>Enregistrer</v-btn>
        <Navigation :elements="AdminNavigation" v-if="user.isAdmin" />
      </v-card-actions>
      <v-card-text>
        <template>
          <v-card v-if="$route.params.item.isAnimateur === true">
            <v-tabs v-model="model" centered>
              <v-tab href="#tabGroupe">
                Groupes
              </v-tab>
              <v-tab href="#tabCampagne">
                Campagnes
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="model">
              <v-tab-item value="tabGroupe">
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(projet, index) in $route.params.item.projets"
                      :key="index"
                    >
                      <groupeDialog
                        v-if="user.role != 'operateur'"
                        :key="$uuid.v4()"
                        :projet="projet.ll_programme"
                        :utilisateur="$route.params.item"
                        @groupCreated="renewId()"
                      />
                    </div>

                    <groupesDeAnimateur
                      :key="$uuid.v4()"
                      :animateur="$route.params.item"
                  /></v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tabCampagne">
                <v-card flat>
                  <v-card-text>
                    <listCampagnesOfUser
                      :key="$uuid.v4()"
                      :animateur="$route.params.item"
                      :user="user"
                  /></v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      model: "tabGroupe",
      text: "Lorem ipsum dolor",
    };
  },
  created() {
    /* if (!this.isAdmin) {
      this.$router.push("/");
    } */

    if (!this.$route.params.item) {
      console.log("pas de paramètres", this.$route.params);

      //this.$router.push("/superviseur");
    }
  },
  components: {
    DialogProjetsDeUser: require("@/components/DialogProjetsDeUser.vue")
      .default,
    DialogLocalisationDeUser: require("@/components/DialogLocalisationDeUser.vue")
      .default,
    DialogRegionsSupervisees: require("@/components/DialogRegionsSupervisees.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
    groupesDeAnimateur: require("@/components/groupes/groupesDeAnimateur.vue")
      .default,
    groupeDialog: require("@/components/groupes/groupeDialog.vue").default,
    listCampagnesOfUser: require("@/components/listCampagnesOfUser.vue")
      .default,
  },

  methods: {
    renewId() {
      this.cle++;
    },
    goToGroupesDeSuperviseurs(superviseur) {
      //console.log(superviseur);
      this.$router.push({
        name: "groupes-listeGroupes-id",
        params: { superviseur },
      });
    },
    ...mapActions({
      goBack: "Navigation/goBack",
    }),
  },
  computed: {
    ...mapState({
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      isAdmin: (state) => state.Auth.isAdmin,
      regionsList: (state) => state.Regions.Regions,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>
<style lang="scss" scoped></style>
